'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var configureTimeOffset = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(response, timestamp) {
    var networkOffset, utpTime, data, timeOffset;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            networkOffset = Math.floor(response.headers && Number(response.headers.get('X-Runtime')) * 1000 || 0);
            utpTime = void 0;
            _context.prev = 2;
            _context.next = 5;
            return response.json();

          case 5:
            data = _context.sent;

            utpTime = camelNormaliser.call(data);
            _context.next = 12;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context['catch'](2);

            utpTime = {};

          case 12:
            timeOffset = utpTime.timeUtcMilliseconds - (timestamp + networkOffset);


            _config2.default.update({ timeOffset: timeOffset });

            return _context.abrupt('return', (0, _extends3.default)({}, utpTime, {
              timeOffset: timeOffset
            }));

          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[2, 9]]);
  }));

  return function configureTimeOffset(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.get = get;

var _apiClient = require('../network/api-client');

var _apiClient2 = _interopRequireDefault(_apiClient);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _caseNormaliser = require('../services/case-normaliser');

var _caseNormaliser2 = _interopRequireDefault(_caseNormaliser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var camelNormaliser = new _caseNormaliser2.default(_caseNormaliser2.default.camelCase);

var API = {
  TIME: '/time'

  /**
   * Wrapper for `/time` API endpoint
   */

};var time = {
  get: get
};

exports.default = time;

/**
 * Get server Time from NTP server, and updates X-TimeOffset header automatically
 * @returns {promise} containing Time object
 */

function get() {
  var timestamp = new Date().getTime();
  return _apiClient2.default.get({ route: API.TIME, normaliseResponse: false, includeAuth: false }).then(function (response) {
    return configureTimeOffset(response, timestamp);
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/time/time.js
// module id = 1195
// module chunks = 0